import { createContext, useContext } from 'react';
import { usePaginationLabel, UsePaginationLabelReturn } from '../hooks';

const PaginationContext = createContext<UsePaginationLabelReturn | null>(null);

export function PaginationContextProvider({
    children,
    defaultPage,
    pageSize,
    queryParamsEnabled,
}: {
    children: React.ReactNode;
    defaultPage: number;
    pageSize: number;
    queryParamsEnabled: boolean;
}) {
    const paginator = usePaginationLabel({
        defaultPage,
        pageSize,
        queryParamsEnabled,
    });

    return (
        <PaginationContext.Provider value={paginator}>
            {children}
        </PaginationContext.Provider>
    );
}

export function usePaginationContext() {
    const context = useContext(PaginationContext);

    if (context === null) {
        throw new Error('usePaginationContext must be used within a PaginationContextProvider');
    }

    return context;
}
